import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  CmIntegrationsResponseSchema,
  type CampaignManagerIntegrationSchema,
} from '../shared/schemas/CampaignManagerSchema.js';
import { OmniTraffickingIntegrationResponseSchema } from '../shared/schemas/OmniTraffickingIntegrationsResponseSchema.js';

export const getCampaignManagerIntegrations = defaultApi.declareEndpoint({
  url: 'campaign_manager/v2/integrations/' as const,
  method: 'GET',
  responseSchema: CmIntegrationsResponseSchema,
});

export const getCampaignManagerIntegrationsOmni = defaultApi.declareEndpoint({
  url: 'omni-trafficking/v1/integrations/?ad_server=campaign_manager' as const,
  method: 'GET',
  responseSchema: OmniTraffickingIntegrationResponseSchema,
});

export const getQueryOptions = makeQueryOptions(
  getCampaignManagerIntegrations,
  {
    processResponse(data) {
      return data;
    },
  },
);

export const getQueryOptionsOmni = makeQueryOptions(
  getCampaignManagerIntegrationsOmni,
  {
    processResponse(data) {
      return data;
    },
  },
);

export type CampaignManagerIntegrationType = z.infer<
  typeof CampaignManagerIntegrationSchema
>;
